import { render, staticRenderFns } from "./commonVehiclesList.vue?vue&type=template&id=f9fda63e&scoped=true"
import script from "./commonVehiclesList.vue?vue&type=script&lang=js"
export * from "./commonVehiclesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fda63e",
  null
  
)

export default component.exports